var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_47_9530)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0011 17.887C17.8688 17.887 20.1935 15.5623 20.1935 12.6947C20.1935 9.82706 17.8688 7.50238 15.0011 7.50238C12.1335 7.50238 9.80884 9.82706 9.80884 12.6947C9.80884 15.5623 12.1335 17.887 15.0011 17.887Z",
    fill: "#1D1D1B",
    stroke: "#1D1D1B",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.15038 25.961C6.1443 25.9709 6.13824 25.9808 6.1322 25.9907H6.18108C8.49252 28.2156 12.0972 29 15.254 29C18.507 29 21.4975 28.2351 23.8202 25.9907H23.8691C23.8631 25.9808 23.857 25.9708 23.8509 25.9609C23.857 25.955 23.863 25.9491 23.869 25.9432H23.84C22.9151 24.4432 21.6236 23.203 20.0866 22.3396C18.5335 21.4672 16.7821 21.0089 15.0007 21.0089C13.2193 21.0089 11.4678 21.4672 9.91471 22.3396C8.37777 23.203 7.08618 24.4432 6.16129 25.9432H6.1322C6.13825 25.9492 6.14431 25.9551 6.15038 25.961Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0033 29.3113C22.4591 29.3113 28.5033 23.2671 28.5033 15.8113C28.5033 8.35543 22.4591 2.31128 15.0033 2.31128C7.54745 2.31128 1.5033 8.35543 1.5033 15.8113C1.5033 23.2671 7.54745 29.3113 15.0033 29.3113Z",
    stroke: "#1D1D1B",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_47_9530"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0 0.80957)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.5217bef54ffd261bf850ced2921b558a.svg";
export { ForwardRef as ReactComponent };